import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
//import { FluoroscopeImage } from '../PatientChart/OR-Note/encounter-note/orfluoroscope-images/orfluoroscope-images.component';
//import { FluoroscopeImageService } from '../Services/FluoroscopeImage/fluoroscope-image.service';

export interface DialogData {

}

@Component({
  selector: 'app-preview-file-or-image',
  templateUrl: './preview-file-or-image.component.html',
  styleUrls: ['./preview-file-or-image.component.css']
})
export class PreviewFileOrImageComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PreviewFileOrImageComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public _DomSanitizationService: DomSanitizer) { 
    }

  ngOnInit() {
    //this.GetFluoroscopeImages();
  }

  // uploadimgList: FluoroscopeImage[] = [];
  // GetFluoroscopeImages() {
  //   this.fluoroscopeService.GetDocumentFluoreScopeImages1().subscribe(
  //     data => {
  //       this.uploadimgList = [];
  //       this.uploadimgList = data;
  //     }, (err: any) => console.log(err));
  // }

  // Imagetransform(base64image) {
  //   return this._DomSanitizationService.bypassSecurityTrustResourceUrl(base64image);
  // }

  // PdfFormat(base64pdf) {
  //   const linkSource = base64pdf
  //   const downloadLink = document.createElement("a");
  //   const fileName = "sample.pdf";

  //   downloadLink.href = linkSource;
  //   downloadLink.download = fileName;
  //   downloadLink.click();
  // }
}
